import script from "./AudioPlayer.vue?vue&type=script&setup=true&lang=ts"
export * from "./AudioPlayer.vue?vue&type=script&setup=true&lang=ts"

import "./AudioPlayer.vue?vue&type=style&index=0&id=3ae08385&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3ae08385"]])

export default __exports__